module.exports = __webpack_public_path__ + "static/fcra-fin-2016-17-2a7aa28800e7d3cb7026bf053855f90b.pdf";